import React from 'react'; 
import { Row, Col, Button, Popconfirm, Switch } from 'antd';
import { EditOutlined, DeleteOutlined, SyncOutlined } from '@ant-design/icons';
import { routeHistory } from '@nackle/biw-web-router';
import { useNavigationContext } from '../../context/navigation-context.jsx';
import { GOLD_COMPANY_ID } from '../../constants.js';
import { getPagePermission } from '../../utils/permissions.js';
import { usePermissions } from '@nackle/umbrella-studio';
import { getStringWithFallback } from '../../utils/strings.js';
const TreeNodeTitle = ( props ) => {
    const { label, route, id, enabled, companyId: itemCompanyId, goldId, isUmbrella } = props;
    const { 
        handleChangeEnabled, 
        currentPage, 
        findNestedRootItemAndApply, 
        updateToCompanyItemRecursively,
        deleteMenuItem
    } = useNavigationContext();

    const { hasPermission } = usePermissions();
    const { companyId } = props.route.params; 

    const handleEditButton = () => {
        if ( companyId !== GOLD_COMPANY_ID && itemCompanyId === GOLD_COMPANY_ID ) {
            // first make new company version of the item
            findNestedRootItemAndApply( id, props.route, updateToCompanyItemRecursively, companyId );
        }
        const pushUrl = getPushUrl( );
        routeHistory.push( pushUrl );
    };

    const getPushUrl = ( newItem ) => {
        const { 
            companyId,
            menuType,
            submenuId,
            submenuName,
            submenuId2,
            submenuName2,
        } = props.route.params;

        const isItem = !props.children && !props.type;

        const bundleLabel = decodeURI( getStringWithFallback( label, companyId, isUmbrella ) );
        let pushUrl = isUmbrella ? '/navigation' : `/${ companyId }`;

        const idToUse = newItem ? newItem.id : id;

        if ( submenuId && !submenuId2 && !isItem ) {
            pushUrl += `/menu-types/${ currentPage.breadcrumbLink }/${ route.params.menuType }/submenu/${ submenuName }/${ submenuId }/submenu/${ bundleLabel }/${ idToUse }`;
        } else if ( submenuId && submenuId2 && !isItem ) {
            pushUrl += `/menu-types/${ currentPage.breadcrumbLink }/${ route.params.menuType }/submenu/${ submenuName }/${ submenuId }/submenu/${ submenuName2 }/${ submenuId2 }`;
        } else if ( submenuId && !submenuId2 && isItem ) {
            pushUrl += `/menu-types/${ currentPage.breadcrumbLink }/${ route.params.menuType }/submenu/${ submenuName }/${ submenuId }/item/${ bundleLabel }/${ idToUse }`;
        } else if ( submenuId && submenuId2 && isItem ) {
            pushUrl += `/menu-types/${ currentPage.breadcrumbLink }/${ route.params.menuType }/submenu/${ submenuName }/${ submenuId }/submenu/${ submenuName2 }/${ submenuId2 }/item/${ bundleLabel }/${ idToUse }`;
        } else if ( !submenuId && !submenuId2 && isItem ) {
            pushUrl += `/menu-types/${ currentPage.breadcrumbLink }/${ menuType }/item/${ bundleLabel }/${ idToUse }`;
        } else {
            pushUrl += `/menu-types/${ currentPage.breadcrumbLink }/${ menuType }/submenu/${ bundleLabel }/${ idToUse }`;
        }

        return pushUrl;
    };

    const checkDeleteDisabled = () => {
        if ( itemCompanyId === companyId ) {
            return true;
        }
        return false;
    };

    const isCompanyCopy = () => {
        return companyId !== GOLD_COMPANY_ID && itemCompanyId !== GOLD_COMPANY_ID && goldId !== null;
    };

    const { topLevel } = props;

    const hasEdit = hasPermission( getPagePermission( 'edit' ) );
    const hasDelete = hasPermission( getPagePermission( 'delete' ) );




    return (
        <Row justify='space-between' align='middle'>
            <Col className='title-text' style={ { color: !enabled ? 'lightgrey' : '#444A53' } }>
                <div>
                    <span>{ getStringWithFallback( label, companyId, isUmbrella ) }</span>
                </div>
            </Col>
            <Col className='icon-buttons'>
                <Switch
                    checked={ enabled }
                    onChange={ () => handleChangeEnabled( id, route ) }
                    className="enabled-switch"
                />

                { topLevel ?
                    <div className="button-container">
                        <Button
                            type='primary'
                            icon={ <EditOutlined className={ !hasEdit ? 'disabled-button' : '' }/> }
                            onClick={ handleEditButton }
                            disabled={ !hasEdit }
                            className="edit-button"
                        >
                        </Button>

                        { checkDeleteDisabled() ?
                            <Popconfirm
                                title={ 
                                    isCompanyCopy() ?
                                    <span>
                                        Are you sure you want to revert this item to its Gold version?
                                        <br /><br />
                                        Once reverted, you will need to Save your changes.
                                    </span>
                                    :
                                    <span>Deleting this item will delete all contents within it. This action cannot be undone.
                                        <br /><br />
                                        Are you sure you want to delete?
                                    </span>
                                }
                                okText={ isCompanyCopy() ? 'Yes' : 'Delete' }
                                okButtonProps={ { type: 'primary', danger: !isCompanyCopy() } }
                                cancelText={ isCompanyCopy() ? 'No' : 'Cancel' }
                                placement='topRight'
                                // icon=''
                                overlayClassName="custom-popconfirm"
                                onConfirm={ () => deleteMenuItem( id, route, companyId ) }
                                disabled={ !hasDelete }
                            >
                                {
                                    isCompanyCopy() ?
                                    <SyncOutlined 
                                        disabled={ !hasDelete }
                                    /> :
                                    <DeleteOutlined 
                                    disabled={ !hasDelete }
                                />
                                }
                                { /* <DeleteOutlined 
                                    className={ `${ ( !enabled || !hasDelete ) ? 'disabled-button' : '' }` }
                                    disabled={ !hasDelete }
                                /> */ }
                            </Popconfirm>
                        : null
                        }
                    </div>
                : null
                }
            </Col>
        </Row>
    );
};

export default TreeNodeTitle;